import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/assets/templates')({
  component: () => <PageStub title="Template Marketplace" description="Ready-to-use business templates" />,
});
